module.exports = __webpack_public_path__ + "img/level3addon_running_gun_mask.bd116c58.png";